import {
    ADMINGETLANGUAGEDROPLIST_SUCCESS,
    ADMINGETLANGUAGEDROPLIST_FAILED,
    RESET_ADMINGETLANGUAGEDROPLIST,
    LOADING_ADMINGETLANGUAGEDROPLIST,
    NETWORK_ERROR_ADMINGETLANGUAGEDROPLIST
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetLanguageDropList = () => {
    return { type: RESET_ADMINGETLANGUAGEDROPLIST };
};

const getLanguageDropListAdmin = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINGETLANGUAGEDROPLIST });
    await adminServices
        .post("getLanguageList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminGetLanguageDropListsuccess(res.data));
                    break;
                default:
                    dispatch(AdminGetLanguageDropListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINGETLANGUAGEDROPLIST,
                payload: err
            });
        });
};


function AdminGetLanguageDropListsuccess(data) {
    return {
        type: ADMINGETLANGUAGEDROPLIST_SUCCESS,
        payload: data
    };
}
function AdminGetLanguageDropListFailed(data) {
    return {
        type: ADMINGETLANGUAGEDROPLIST_FAILED,
        payload: data
    };
}

export { getLanguageDropListAdmin, resetAdminGetLanguageDropList }